<template>
  <div class="page-container">
    <div v-loading="loading" class="loading-container">
      <div class="header">
        <div class="title">广东元正招标采购有限公司</div>
        <div class="title-line"></div>
        <div class="title-line" style="margin-top: 2px;"></div>
      </div>
    
    <div class="contnet-title">
      领取通知
    </div>
    
    <div class="content">
      <p class="company-title"><strong>{{ psu.comfullname }}：</strong></p>
      <p class="content-text">经评审，贵单位为<strong>{{ psu.projectname }}</strong>【项目编号：<strong>{{ psu.projectcode }}</strong>】的{{ prsflgDesc }}人，{{ amountDesc }}。请贵单位及时办理{{ prsflgDesc }}通知书领取手续。</p>
      
      <p class="content-text">本项目采购代理服务费为<strong style="text-decoration: underline;">¥{{ psu.psuconfirmfeeamt | qfwVal }}元（人民币{{ psu.psuconfirmfeeamt | smallToBigVal }}）</strong>，贵单位应于<strong style="text-decoration: underline;">{{ paymentDeadline }}</strong>之前，以银行划帐（须用公账）的方式向我司缴纳，我司收款账户信息如下：</p>
      
      <div class="account-info">
        <div class="account-item">
          <span class="account-label">开户名称：</span>
          <span class="account-value">{{ accountInfo.name }}</span>
        </div>
        <div class="account-item">
          <span class="account-label">开户银行：</span>
          <span class="account-value">{{ accountInfo.bank }}</span>
        </div>
        <div class="account-item">
          <span class="account-label">开户账号：</span>
          <span class="account-value">{{ accountInfo.number }}</span>
        </div>
        <div class="account-item">
          <span class="account-label">注明用途：</span>
          <span class="account-value">{{ psu.projectcode }} {{ prsflgDesc }}服务费</span>
        </div>
      </div>
      
      <p class="content-text">付款后，请登录南方采购交易平台（<a href="http://j.eebidding.com" target="_blank">http://j.eebidding.com</a>），在 "工作台" — "成交管理" 中找到成交记录，点击 "申请发票"，选择开票类型：增值税普通发票电子票（适用于小规模纳税人），增值税专用发票电子票（适用于一般纳税人），填写其它资料，上传服务费的转账凭证底单，点击保存，即可完成发票申请。</p>
      
      <p class="content-text">服务费到账后，我司将开具数字电子发票，发至贵单位本项目报名人的电子邮箱。贵单位可登录平台，在 "工作台" — "成交管理" 中找到对应的成交记录，在通知书栏位上点击 "领取"，在通知书页面上打印或下载电子{{ prsflgDesc }}通知书，凭此通知书与采购人办理后续的{{ prsflgDesc }}事宜。</p>
      
      <p class="content-text">特此通知！</p>
      
      <div class="contact-info">
        <div class="contact-item">
          <span class="contact-label"><strong>项目联系人及电话：</strong></span>
          <span class="contact-value">{{ psu.projectatel }}</span>
        </div>
        <div class="contact-item">
          <span class="contact-label"><strong>联系邮箱：</strong></span>
          <span class="contact-value">{{ psu.auseremail || 'gdzy05@163.com' }}</span>
        </div>
      </div>
      
      <div class="company-footer">
        <img v-if="Osealurl && Osealurl.length > 0" class="img" :src="uploadAddr + Osealurl[0].appendurl" width="170" height="170"/>
        <div style="position: relative; z-index: 998;" v-if="Osealurl && Osealurl.length > 0">
          <div class=company-name>
            {{ Osealurl[0].comfullname }}
          </div>
          <div class="date">{{ psu.psuconfirmtime | ConverToDate }}</div>
        </div>
        <div v-else>
          <div class="company-name">广东元正招标采购有限公司</div>
          <div class="date">{{ psu.psuconfirmtime | ConverToDate }}</div>
        </div>
      </div>
      
      <div style="clear: both;"></div>
    </div>
      </div>
    
    <div style="position: fixed; bottom: 10px; left: 0; right: 0; width: 90%;margin: 0 auto;">
      <div class="bottom-line"></div>
      <div class="bottom-line" style="margin-top: 2px;"></div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request"
import utils from "../../assets/js/utils";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  data() {
    return {
      psu: {},
      projectid: this.$route.query.projectid,
      psuid: this.$route.query.psuid,
      loading: false,
      Osealurl: [],
      accountInfo: {
        name: '',
        bank: '',
        number: ''
      }
    };
  },
  async created() {
    this.loading = true;
    try {
      await this.getPsu();
      await this.getComListbypid();
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async getPsu() {
      let res = await request({
        method: "get",
        url: "/xmgl/project/getpsubyid",
        params: { psuid: this.psuid },
      });
      if (res.length) {
        this.psu = res[0];
      }
    },
    async getComListbypid() {
      let res = await request({
        method: "get",
        url: "/xmgl/project/getComListbypid",
        params: {
          projectid: this.projectid,
          cosid: this.loginUser.cosid
        },
      });
      this.Osealurl = res.filter((e) => +e.appendtype === 4);
      
      // 获取账户信息
      if (res && res.length > 0) {
        let firstItem = res[0];
        if (+firstItem.dptbranchfalg === 1) {
          this.accountInfo = {
            name: firstItem.dptfullname || '',
            bank: firstItem.dptbank || '',
            number: firstItem.dptbanknumber || ''
          };
        } else {
          this.accountInfo = {
            name: firstItem.comfullname || '',
            bank: firstItem.combank || '',
            number: firstItem.combanknumber || ''
          };
        }
      }
    },
  },
  computed: {
    prsflgDesc() {
      return this.psu.prsflg !== '6' ? '成交' : '中选';
    },
    amountDesc() {
      const isSelected = this.psu.prsflg === '6';
      const prefix = isSelected ? '中选' : '成交';
      
      if (+this.psu.projectquotationmode === 1) {
        return `${prefix}金额：¥${this.$options.filters.qfwVal(this.psu.psuamt)}（人民币${this.$options.filters.smallToBigVal(this.psu.psuamt)}）`;
      } else {
        let suffix = '';
        switch (+this.psu.projectquotationmode) {
          case 2:
            suffix = '上浮率';
            break;
          case 3:
            suffix = '下浮率';
            break;
          case 4:
            suffix = '折扣率';
            break;
        }
        return `${prefix}${suffix}：${this.psu.psupricerate}%`;
      }
    },
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    paymentDeadline() {
      if (!this.psu.psuconfirmtime) return '2026年3月9日';
      let date = dayjs(this.psu.psuconfirmtime);
      let workdays = 7;
      let currentDay = date;
      
      while (workdays > 0) {
        currentDay = currentDay.add(1, 'day');
        let dayOfWeek = currentDay.day();
        // 排除周末（0是周日，6是周六）
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          workdays--;
        }
      }
      
      return currentDay.format('YYYY年MM月DD日');
    },
    ...mapGetters(["loginUser"]),
  },
  filters: {
    qfwVal(value) {
      return utils.comdify(value);
    },
    smallToBigVal(v) {
      return utils.smallToBig(v)
    },
    ConverToDate(data) {
      let date = new Date(data);
      var chinese = ["O", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      var y = date.getFullYear().toString();
      var m = date.getMonth() + 1;
      m = m.toString();
      var d = date.getDate().toString();
      var result = "";
      for (let i = 0; i < String(y).length; i++) {
        let z = y[i];
        result += chinese[z];
      }
      result += "年";
      if (m.length === 2) {
        if (+m[0] === 1) {
          if (+m[1] === 0) {
            result += "十月";
          } else {
            result += "十" + chinese[m.charAt(1)] + "月";
          }
        }
      } else {
        result += chinese[m.charAt(0)] + "月";
      }

      if (d.length == 2 && +d.charAt(1) !== 0) {
        if (+d.charAt(0) === 1) {
          result += '十' + chinese[d.charAt(1)] + "日";
        } else {
          result += chinese[d.charAt(0)] + '十' + chinese[d.charAt(1)] + "日";
        }
      } else if (d.length == 2 && +d.charAt(1) == 0) {
        if (+d.charAt(0) === 1) {
          result += '十日'
        } else {
          result += chinese[d.charAt(0)] + '十' + "日";
        }
      } else {
        result += chinese[d.charAt(0)] + "日";
      }
      return result;
    },
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

.loading-container {
  width: 100%;
  flex: 1;
  position: relative;
}
.title {
  color: #FF0000;
  font-weight: bold;
  font-size: 32px;
  text-align: center;
  font-family: '宋体';
  display: block;
  margin: 10px 0;
}

.title-line {
  width: 100%;
  border: 2px solid #FF0000;
  margin: 0 auto;
}

.contnet-title {
  color: #0c0d0b;
  text-align: center;
  font-size: 24px;
  margin: 20px 0;
  font-family: '宋体';
  font-weight: bold;
}

.content {
  padding: 0 40px;
  font-family: '宋体';
  line-height: 24px;
  flex: 1;
}

.company-title {
  font-weight: bold;
  margin: 15px 0;
  font-size: 16px;
  line-height: 24px;
}

.content-text {
  color: #000;
  line-height: 24px;
  margin: 10px 0;
  text-align: justify;
  text-indent: 2em;
}

.account-info {
  margin: 15px 0 20px 0;
  padding-left: 40px;
  font-family: '宋体';
  line-height: 24px;
}

.account-item {
  margin: 6px 0;
  display: flex;
  align-items: flex-start;
  line-height: 24px;
}

.account-label {
  width: 100px;
  font-weight: bold;
  flex-shrink: 0;
  line-height: 24px;
}

.account-value {
  flex: 1;
  line-height: 24px;
}

.contact-info {
  margin: 15px 0 20px 0;
  padding-left: 2em;
  font-family: '宋体';
  line-height: 24px;
}

.contact-item {
  margin: 6px 0;
  display: flex;
  align-items: flex-start;
  line-height: 24px;
}

.contact-label {
  width: 180px;
  font-weight: bold;
  flex-shrink: 0;
  line-height: 24px;
}

.contact-value {
  flex: 1;
  line-height: 24px;
}

.company-footer {
  margin: 30px 40px 10px 0;
  font-family: '宋体';
  line-height: 24px;
  text-align: right;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  height: 80px;
  float: right;
}

.company-footer .img {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 991;
  width:  180px;
  height: 180px;
}

.company-footer .company-name {
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  width: 200px;
}

.company-footer .date {
  margin-top: 5px;
  line-height: 24px;
  text-align: center;
  width: 200px;
}

.bottom-line {
  width: 100%;
  border: 2px solid #FF0000;
  margin: 0 auto;
}
</style>
<style lang="scss">
@media print {
  body {
    height: 100vh !important;
    margin: 0;
    padding: 0;
  }
  
  .page-container {
    min-height: 100vh !important;
    display: flex;
    flex-direction: column;
  }
  
  .loading-container {
    flex: 1;
  }
  

}
</style>
